import { render, staticRenderFns } from "./LandwirtePage.vue?vue&type=template&id=229385d0&"
import script from "./LandwirtePage.vue?vue&type=script&lang=js&"
export * from "./LandwirtePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports